// store/slices/processedDataSlice.ts

export interface ProcessingStatus {
  status: "idle" | "processing" | "completed" | "failed";
  progress: number;
  currentStep: string;
  error?: string;
  trackerId?: string | null;
  mailchimpKeyId?: string;
  reportId?: string | null;
  notificationId?: string | null;
}
export interface ProcessedDataState {
  processedData: {
    keyId?: string;
    _id?: string;
    campaignsData?: any;
    automationData?: any;
    allEmails?: any;
    ecommerceData?: any;
    revenueData?: any;
    subscribersData?: any;
    deliverabilityMetrics?: any;
  };
  processingStatus: ProcessingStatus;
  isFetched: boolean;
  lastFetchedKeyId: string | null;
}

export interface ProcessedDataActions {
  setProcessedData: (data: any, keyId?: string) => void;
  addProcessedData: (data: any) => void;
  updateProcessingStatus: (
    status: Partial<ProcessedDataState["processingStatus"]>,
  ) => void;
  resetProcessingStatus: () => void;
  setIsFetched: (isFetched: boolean) => void;
  invalidateProcessedData: () => void;
}

const initialProcessingStatus: ProcessingStatus = {
  status: "idle",
  progress: 0,
  currentStep: "",
  error: undefined,
  trackerId: null,
};

export const processedDataSlice = (
  set: any,
): { data: ProcessedDataState; actions: ProcessedDataActions } => ({
  data: {
    processedData: {},
    processingStatus: initialProcessingStatus,
    isFetched: false,
    lastFetchedKeyId: null,
  },
  actions: {
    setProcessedData: (data: any, keyId?: string) => {
      set((state: any) => {
        state.data.processedData = data;
        state.data.isFetched = true;
        if (keyId) {
          state.data.lastFetchedKeyId = keyId;
        }
      });
    },
    addProcessedData: (data: any) => {
      set((state: any) => {
        state.data.processedData = { ...state.data.processedData, ...data };
      });
    },
    updateProcessingStatus: (
      status: Partial<ProcessedDataState["processingStatus"]>,
    ) => {
      set((state: any) => {
        state.data.processingStatus = {
          ...state.data.processingStatus,
          ...status,
        };
      });
    },
    resetProcessingStatus: () => {
      set((state: any) => {
        state.data.processingStatus = {
          mailchimpKeyId: state.data.processingStatus.mailchimpKeyId,
          status: "idle",
          progress: 0,
          currentStep: "",
          notificationId: null,
        };
      });
    },
    setIsFetched: (isFetched: boolean) => {
      set((state: any) => {
        state.data.isFetched = isFetched;
      });
    },
    invalidateProcessedData: () => {
      set((state: any) => {
        state.data.processedData = {};
        state.data.isFetched = false;
        state.data.lastFetchedKeyId = null;
      });
    },
  },
});
